import React from 'react'
import PropTypes from 'prop-types'
import { ModalHeader } from 'reactstrap'

import { EloButton } from '@elo-kit/components/elo-button/EloButton'

import './seller-warning-modal.scss'

export const SellerWarningModal = (props) => {
  const { openAsSeller, toggle } = props

  return (
    <>
      <div className='seller-warning-modal__container'>
        <ModalHeader toggle={toggle} />
        <div className='seller-warning-modal__title'>{I18n.t('react.shared.comminity.seller_warning_modal_title')}</div>
        <div className='seller-warning-modal__message'>
          {I18n.t('react.shared.comminity.seller_warning_modal_content')}
        </div>
        <EloButton outlined className='seller-warning-modal__button' onClick={openAsSeller}>
          {I18n.t('react.shared.comminity.seller_warning_modal_button')}
        </EloButton>
      </div>
    </>
  )
}

SellerWarningModal.displayName = 'SellerWarningModal'
SellerWarningModal.propTypes = {
  openAsSeller: PropTypes.func,
  toggle: PropTypes.func,
}
SellerWarningModal.defaultProps = {
  openAsSeller: () => {},
  toggle: () => {},
}
